var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title:
          "" +
          (_vm.isClassTeacher
            ? "添加任课班主任"
            : "添加任课教师-" + _vm.identify.subjectName),
        visible: _vm.dialogVisible,
        "custom-class": "zyyj-dialog",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.handleOpen
      }
    },
    [
      _c("div", { staticClass: "menu-container scroll" }, [
        _c(
          "div",
          { staticClass: "content scroll" },
          [
            _c(
              "el-checkbox-group",
              {
                model: {
                  value: _vm.checkList,
                  callback: function($$v) {
                    _vm.checkList = $$v
                  },
                  expression: "checkList"
                }
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.teacherList, function(person, key, index) {
                    return _c("li", { key: index + "-person" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "min-height": "28px",
                            "line-height": "1",
                            width: "100%"
                          },
                          attrs: { id: "anchor-" + key }
                        },
                        [
                          _c("label", { staticClass: "key" }, [
                            _vm._v(_vm._s(key.toUpperCase()))
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                "margin-left": "10px",
                                width: "calc(100% - 30px)"
                              }
                            },
                            [
                              _vm._l(person, function(teacher) {
                                return [
                                  teacher
                                    ? _c(
                                        "el-checkbox",
                                        {
                                          key: teacher.value,
                                          attrs: { label: teacher.value }
                                        },
                                        [
                                          _c(
                                            "el-tooltip",
                                            { attrs: { placement: "top" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [_vm._v(_vm._s(teacher.name))]
                                              ),
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(_vm._s(teacher.name))
                                              ]),
                                              _vm._v(
                                                "\n                      >"
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  }),
                  0
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "ul",
          { staticClass: "menu" },
          _vm._l(_vm.menuIndex, function(item) {
            return _c(
              "li",
              {
                key: item,
                class: _vm.active === item ? "active" : "menu-item",
                on: {
                  click: function($event) {
                    return _vm.clickMenu(item)
                  }
                }
              },
              [_vm._v("\n        " + _vm._s(item) + "\n      ")]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.closeDialog } },
            [_vm._v("取 消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                disabled: _vm.submitting
              },
              on: { click: _vm.submitSubject }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-03855d00", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-03855d00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/school-admin/affair/SubjectTeacherEditor.vue
// module id = null
// module chunks = 